import React from "react";

function HorseDetails({ product }) {
    if (!product) return <p>Məlumat tapılmadı.</p>;

    return (
        <div className="horse-details">
            <h3>At Məlumatları</h3>
            <ul>
                <li><strong>Ad:</strong> {product.name || "Bilinmir"}</li>
                <li><strong>Cins:</strong> {product.horseBreed || "Bilinmir"}</li>
                <li><strong>Yaş:</strong> {product.age ? `${product.age} yaş` : "Bilinmir"}</li>
                <li><strong>Cinsiyyət:</strong> {product.gender || "Bilinmir"}</li>
                <li><strong>Hündürlük:</strong> {product.height ? `${product.height} sm` : "Bilinmir"}</li>
                <li><strong>Çəki:</strong> {product.weight ? `${product.weight} kq` : "Bilinmir"}</li>
                <li><strong>Rəng:</strong> {product.color || "Bilinmir"}</li>
                <li><strong>Sağlamlıq vəziyyəti:</strong> {product.healthStatus || "Bilinmir"}</li>
                <li><strong>İstifadə sahəsi:</strong> {product.usage || "Bilinmir"}</li>
                <li><strong>Şəhər:</strong> {product.city || "Bilinmir"}</li>
                    <li style={{flexDirection:"column"}}>
                    <strong>Əlavə təsvir</strong>
                    <p >
                        {product.description || "Açıqlama mövcud deyil."}
                    </p>
                </li>
            </ul>
          
        </div>
    );
}

export default HorseDetails;
